import { render, staticRenderFns } from "./VdBindAdmin.vue?vue&type=template&id=1d7907b2&scoped=true"
import script from "./VdBindAdmin.vue?vue&type=script&lang=ts"
export * from "./VdBindAdmin.vue?vue&type=script&lang=ts"
import style0 from "./VdBindAdmin.vue?vue&type=style&index=0&id=1d7907b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7907b2",
  null
  
)

export default component.exports